// extracted by mini-css-extract-plugin
export var auto = "_2y-1";
export var spinner = "_2y-0";